import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SectionTitle = styled.div`
  ${TypographyV2.h5};
  color: ${ColorV2.Blue4};
`;

export const DetailsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
`;

export const EditDetailsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
`;

export const EditTotalsRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  margin-top: 12px;
`;

export const EditTimeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const EditActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const DetailsMessage = styled.div`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue4};
  text-align: center;
  padding: 24px 0;
`;

export const DetailsLoader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 24px 0;
`;

export const DetailsSpinner = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 3px solid ${ColorV2.Blue6};
  border-top-color: ${ColorV2.Blue1};
  animation: scheduleSpin 0.8s linear infinite;

  @keyframes scheduleSpin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const DetailBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DetailValue = styled.div`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
`;

export const DetailLabel = styled.div`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const ShiftCompletedText = styled.div`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue4};
  opacity: 0.5;
`;

export const FooterNote = styled.div`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue4};
  opacity: 0.5;
  text-align: right;
`;
